import { LIST_MARINE_VEHICLE_TYPES } from '../enums/marineVehicleTypes';

export default function isMarineVehicleType(type) {
    return LIST_MARINE_VEHICLE_TYPES.includes(type);
}
